import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import isPermission, { allPermissions } from './services/permission';

import Login from './pages/Login/Login';
import PasswordRecovery from './pages/PasswordRecovery/PasswordRecovery';
import Home from './pages/Home/Home';
import Usuarios from './pages/Usuarios/Usuarios';
import CadastroUsuario from './pages/Usuarios/CadastroUsuario';
import Profile from './pages/Usuarios/Profile';
import Escritorio from './pages/Escritorio/Escritorio';
import Clientes from './pages/Clientes/Clientes';
import Processos from './pages/Processos/Processos';
import PageCadastroProcesso from './pages/Processos/PageCadastroProcesso';
import Consultas from './pages/Consultas/Consultas';
import Cadastros from './pages/Cadastros/Cadastros';
import Corretores from './pages/Cadastros/Corretores';
import DocumentosAvulsos from './pages/DocumentosAvulsos/DocumentosAvulsos';
import Agendamentos from './pages/Agendamentos/Agendamentos';
import ContasReceber from './pages/ContasReceber/ContasReceber';
import ContasPagar from './pages/ContasPagar/ContasPagar';
import WhatsappContainer from './pages/Whatsapp/WhatsappContainer';
import MessageContainer from './pages/Messages/MessageContainer';
import MessageConfig from './pages/MessageConfig/MessageConfig';
import LicenseDashboard from './pages/License/LicenseDashboard';
import RenewPlan from './pages/RenewPlan/RenewPlan';
import CadastroEscritorioAdvogado from './pages/Escritorio/CadastroEscritorioAdvogado';
import Bloqueio from './pages/Bloqueio/Bloqueio';
import Congratulations from './pages/Escritorio/Congratulations';
import ContractPlan from './pages/RenewPlan/ContractPlan';
import RedefinirSenha from './pages/Login/RedefinirSenha';
import Tarefas from './pages/Tarefas/Tarefas';
import Configuracoes from './pages/Configuracoes/Configuracoes';
import Administrativo from './pages/Administrativo/Administrativo';

const isAuthentication = (path: any) => {
    const infoLogin = sessionStorage.getItem('infoLogin') || null;
    if(infoLogin){
        return true;
    }else{
        return false;
    }
};

type PrivateRouteProps = {
    component: () => JSX.Element,
    path?: any,
};

const PrivateRoute = (props: PrivateRouteProps) => {
    const { component: Component, path = null } = props;
    const infoLogin = sessionStorage.getItem('infoLogin') || null;
    const isDisabled = sessionStorage.getItem('isDisabled') || null;
    if(infoLogin){
        if(isDisabled) return <Bloqueio />;
        return <Component/>
    }
    return <Navigate replace to={"/login"} />
};

const LoginRoute = () => {
    return isAuthentication(null) ? <Navigate replace to={"/"} /> : <Login />
}

export default function MyRoutes() {
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<LoginRoute />} />
                <Route path="/recuperarsenha" element={<PasswordRecovery />} />
                <Route path="/cadastro/:plano" element={<CadastroEscritorioAdvogado />} />
                <Route path="/congratulations" element={<Congratulations />} />
                <Route path="/pagamento/:plano" element={<ContractPlan />} />
                <Route path="/redefinirsenha" element={<RedefinirSenha />} />
                
                <Route path="/" element={<PrivateRoute component={Home} />} />
                <Route path="/usuarios" element={<PrivateRoute component={Usuarios} />} />
                <Route path="/cadastrousuario" element={<PrivateRoute component={CadastroUsuario} />} />
                <Route path="/profile" element={<PrivateRoute component={Profile} />} />
                <Route path="/escritorio" element={<PrivateRoute component={Escritorio} />} />
                <Route path="/clientes" element={<PrivateRoute component={Clientes} />} />
                <Route path="/processos" element={<PrivateRoute component={Processos} />} />
                <Route path="/consultas" element={<PrivateRoute component={Consultas} />} />
                <Route path="/cadastroprocesso" element={<PrivateRoute component={PageCadastroProcesso} />} />
                <Route path="/cadastros" element={<PrivateRoute component={Cadastros} />} />
                <Route path="/corretores" element={<PrivateRoute component={Corretores} />} />
                <Route path="/documentosavulsos" element={<PrivateRoute component={DocumentosAvulsos} />} />
                <Route path="/agendamentos" element={<PrivateRoute component={Agendamentos} />} />
                <Route path="/receber" element={<PrivateRoute component={ContasReceber} />} />
                <Route path="/pagar" element={<PrivateRoute component={ContasPagar} />} />
                <Route path="/whatsapp" element={<PrivateRoute component={WhatsappContainer} />} />
                <Route path="/mensagens" element={<PrivateRoute component={MessageContainer} />} />
                <Route path="/configmessage" element={<PrivateRoute component={MessageConfig} />} />
                <Route path="/tarefas" element={<PrivateRoute component={Tarefas} />} />
                <Route path="/configuracoes" element={<PrivateRoute component={Configuracoes} />} />
                <Route path="/administrativo" element={<PrivateRoute component={Administrativo} />} />
                <Route path="/license" element={<PrivateRoute component={LicenseDashboard} />} />
                <Route path="/planocontrato" element={<PrivateRoute component={RenewPlan} />} />
            </Routes>
        </BrowserRouter>
    );
}